import gql from 'graphql-tag';

export const updateFoundationCommitteeMutation = gql`
  mutation updateFoundationCommittee($committeeInfo: UpdateCommitteeInput!) {
    updateCommittee(input: $committeeInfo) {
      code
      message
      success
      committee {
        id
        collaborationName
        name
        description
        category
        url
      }
    }
  }
`;
